// extracted by mini-css-extract-plugin
export default {"wrapper":"Airlines-module__wrapper___StAvi","button":"Airlines-module__button___vI3Te"};